
import { FixJournalReflectionResponseItem } from "@/api/classroomTransfer";
import MBaseModal from "@/components/MBaseModal.vue";
import MButton from "@/components/MButton.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MBaseModal,
    MButton
  },
  props: {
    results: { type: Array, required: true },
    schoolNameMap: { type: Object, required: true }
  },
  emits: ["close"]
})
export default class JournalResultModal extends Vue {
  results!: FixJournalReflectionResponseItem[];
  schoolNameMap!: Record<string, string>;

  getStatusLabel(result: FixJournalReflectionResponseItem): string {
    if (result.status === "failure") {
      return "失敗";
    }
    if (result.status === "success" && result.fixedStudentCount === 0) {
      return "問題なし（修正対象なし）";
    }
    if (result.status === "success") {
      return "成功";
    }
    return "一部失敗";
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case "success":
        return "bg-green-100 text-green-700";
      case "partial":
        return "bg-yellow-100 text-yellow-700";
      case "failure":
        return "bg-red-100 text-red-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  }
}
